import Icon from '../components/Icon.vue'

Icon.register({
  'laptop-code': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M255 261.6C261.3 267.9 271.4 267.9 277.7 261.6L289 250.3C295.2 244.1 295.2 234 289 227.7L253.3 192 289 156.3C295.2 150 295.2 139.9 289 133.6L277.6 122.3C271.4 116.1 261.3 116.1 255 122.3L196.7 180.7C190.4 186.9 190.4 197.1 196.7 203.3L255 261.6zM351 250.3L362.4 261.7C368.6 267.9 378.7 267.9 385 261.7L443.3 203.3C449.6 197.1 449.6 186.9 443.3 180.7L385 122.3C378.7 116.1 368.6 116.1 362.4 122.3L351 133.7C344.8 139.9 344.8 150 351 156.3L386.8 192 351 227.7C344.8 234 344.8 244.1 351 250.3zM624 416H381.5C380.8 435.8 366.8 448 348.8 448H288C269.3 448 255 430.5 255.2 416H16C7.2 416 0 423.2 0 432V448C0 483.2 28.8 512 64 512H576C611.2 512 640 483.2 640 448V432C640 423.2 632.8 416 624 416zM576 48C576 21.6 554.4 0 528 0H112C85.6 0 64 21.6 64 48V384H576V48zM512 320H128V64H512V320z'
      }
    ]
  }
})
